import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Portal from 'react-portal';
import cn from 'classnames';

import './style.scss';

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
class Modal extends Component {
  // FIXME: [fixme-ref:#1]
  // react-portal <= 3.2.0 has issue with children properties updating
  // because it react-router cannot properly react when the url has changed
  // so then it requires `forceUpdate` to pass latest props to children
  // ---
  // react-router >= 4.2.0 has not this issue but it has changed interface
  // so there is not easy way to apply this
  componentDidMount() {
    const { _fixPortal } = this.props;

    if (_fixPortal) {
      this.mounted = true;
    }
  }

  // FIXME: Remove when [fixme-ref:#1] resolved
  componentDidUpdate() {
    const { _fixPortal } = this.props;

    if (_fixPortal && this.mounted) {
      setTimeout(() => this.mounted && this.forceUpdate());
    }
  }

  // FIXME: Remove when [fixme-ref:#1] resolved
  componentWillUnmount() {
    const { _fixPortal } = this.props;

    if (_fixPortal) {
      this.mounted = false;
    }
  }

  render() {
    const {
      children,
      isOpen,
      maxWidth,
      closeOnEsc,
      onCloseRequest,
      className,
    } = this.props;

    return (
      <Portal
        closeOnEsc={closeOnEsc}
        data-test="modal"
        isOpened={isOpen}
        onClose={onCloseRequest}
      >
        <div
          styleName={cn('modal', {
            'is-active': isOpen,
          })}
        >
          <div
            data-test="modal-background"
            styleName="modal__background"
            onClick={onCloseRequest}
          />
          <div
            className={className}
            data-test="modal-card"
            style={{ maxWidth }}
            styleName="modal__card"
          >
            {children}
          </div>
        </div>
      </Portal>
    );
  }
}

Modal.propTypes = {
  // FIXME: Remove when [fixme-ref:#1] resolved
  _fixPortal: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  closeOnEsc: PropTypes.bool,
  isOpen: PropTypes.bool,
  maxWidth: PropTypes.number,
  onCloseRequest: PropTypes.func,
};

Modal.defaultProps = {
  maxWidth: 580,
  children: null,
  isOpen: false,
  closeOnEsc: false,
  className: '',
};

export default Modal;

export { default as ModalHeader } from './components/ModalHeader';
export { default as ModalBody } from './components/ModalBody';
export { default as ModalFooter } from './components/ModalFooter';
